<template>
    <shared-marketplace-provide-report-product :product="product" :image="getImage()"/>
</template>

<script>
  import SharedMarketplaceProvideReportProduct from '@/components/marketplace/shared/provide/report/Product'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      getImage () {
        if (this.product.images[0] !== undefined) {
          return this.product.images[0]
        }
        return ''
      }
    },
    components: {
      SharedMarketplaceProvideReportProduct
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?8ba04576